// La boutique du club (D-181, précise D-150 et D-154 ; maquettes b1 à b10, c1 à c7, d1 validées ; réflexion du 4 novembre) :
// trois façons de vendre qui cohabitent — « Au club » (articles en stock, retrait au club), « Commande groupée » (catalogue
// de l'équipementier, tailles, flocage, fenêtres), « Chez l'imprimeur » (une vitrine : l'imprimeur vend, livre et reprend).
// Une seule page, rangée par façon de recevoir. Ici, ce qui ne dépend que des données : les prix, le stock dit en mots, la
// fenêtre d'une commande groupée et sa barre, les étapes du suivi, le récapitulatif pour l'équipementier (et son tableur),
// l'« À faire » de la personne Boutique, l'adresse d'un imprimeur. Logique pure, testée (boutique.test.ts). Tutoiement.

export type Picto = 'hoodie' | 'zip' | 'jersey' | 'bottle' | 'socks' | 'ball' | 'shorts' | 'track' | 'bag' | 'tee' | 'cap' | 'scarf';
export const PICTOS: { k: Picto; label: string }[] = [
  { k: 'hoodie', label: 'Sweat à capuche' }, { k: 'zip', label: 'Sweat zippé' }, { k: 'jersey', label: 'Maillot' }, { k: 'tee', label: 'T-shirt' },
  { k: 'shorts', label: 'Short' }, { k: 'track', label: 'Survêtement' }, { k: 'socks', label: 'Chaussettes' }, { k: 'bottle', label: 'Gourde' },
  { k: 'ball', label: 'Ballon' }, { k: 'bag', label: 'Sac' }, { k: 'cap', label: 'Casquette' }, { k: 'scarf', label: 'Écharpe' },
];

export interface SizeStock { s: string; n: number }
export interface ShopItem { id: string; name: string; picto: Picto | null; photo: string | null; price_cents: number; sizes: SizeStock[]; in_app?: boolean; on_site?: boolean }
export interface Product { id: string; name: string; picto: Picto | null; photo: string | null; sizes: string[]; price_cents: number; flock_name: boolean; flock_number: boolean; enabled?: boolean }
export interface Round {
  id: string; group_id: string; name: string; label: string; kind: 'month' | 'once'; day_from: number | null; day_to: number | null;
  opens_at: string; closes_at: string; upcoming?: boolean; pieces: number; min_pieces: number | null;
  flock_name_cents: number | null; flock_number_cents: number | null; delivery_note: string | null; mine?: number; mine_for?: string[]; products: Product[];
}
export interface PrinterItem { id: string; url: string; name: string; photo: string | null; price_cents: number; state?: 'ok' | 'missing'; checked_at?: string | null; missing_since?: string | null; position?: number }
export interface ShopSettings {
  sell_club: boolean; sell_group: boolean; sell_printer: boolean; pickup_place: string | null; pickup_when: string | null; pay_at_pickup: boolean;
  printer_url: string | null; printer_name: string | null;
}
export interface Whom { person_id: string; first: string; self: boolean; team: string | null; number: number | null }
export interface Wish { id: string; first: string; kind: 'club' | 'group' | 'printer'; ref_id: string; at: string }
export interface ShopState {
  settings: ShopSettings; pay_ok: boolean; demo: boolean; minor: boolean; manager: boolean; club_name: string;
  items: ShopItem[]; rounds: Round[]; printer: PrinterItem[]; whom: Whom[]; me: string; wishes: Wish[];
  my_wishes: { kind: Wish['kind']; ref_id: string }[]; parents: string[]; open_orders: number; handover: number;
}

export type LineState = 'pending' | 'paid' | 'ordered' | 'ready' | 'given' | 'cancelled';
export type RoundState = 'open' | 'closed' | 'ordered' | 'received' | 'done' | 'cancelled';
export interface OrderLine {
  id: string; kind: 'club' | 'group'; name: string; picto: Picto | null; photo?: string | null; size: string; qty: number; unit_cents: number;
  flock_name: string | null; flock_number: number | null; for: string | null; state: LineState; ready_at: string | null; given_at: string | null;
  given_to: string | null; given_to_kind: 'self' | 'parent' | 'other' | null;
  round: { id: string; label: string; name: string; kind: 'month' | 'once'; state: RoundState; closes_at: string; closed_at: string | null; ordered_at: string | null;
    received_at: string | null; delivery_note: string | null } | null;
}
export interface Order {
  id: string; ref: string; state: 'pending' | 'paid' | 'pickup' | 'abandoned' | 'cancelled'; pay_mode: 'helloasso' | 'retrait' | 'demo'; total_cents: number;
  created_at: string; paid_at: string | null; refund_due: boolean; buyer?: string | null; lines: OrderLine[];
  pickup_place?: string | null; pickup_when?: string | null; club_name?: string;
}

export interface AdminRound {
  id: string; group_id: string; name: string; kind: 'month' | 'once'; label: string; state: RoundState; opens_at: string; closes_at: string;
  closed_at: string | null; ordered_at: string | null; received_at: string | null; done_at: string | null; min_pieces: number | null;
  day_from: number | null; day_to: number | null; coach_handover: boolean; pieces: number; families: number; paid_cents: number; given: number; to_give: number;
}
export interface Group {
  id: string; name: string; kind: 'month' | 'once'; day_from: number | null; day_to: number | null; closes_on: string | null; min_pieces: number | null;
  flock_name_cents: number | null; flock_number_cents: number | null; notify: boolean; delivery_note: string | null; coach_handover: boolean; products: Product[];
}
export interface ReadyLine {
  id: string; order: string; order_id?: string; buyer: string; for: string | null; name: string; picto: Picto | null; size: string; qty: number; kind: 'club' | 'group';
  flock_name: string | null; flock_number: number | null; round_id?: string | null; round?: string; team: string | null; unpaid: boolean; total_cents: number;
  ready_at?: string | null; parents: string[];
}
export interface AdminState {
  settings: ShopSettings & { ha_state: 'none' | 'pending' | 'ok' | 'unverified' | 'error'; ha_name: string | null; ha_checked_at: string | null; ha_error: string | null;
    ha_keys: boolean; printer_visuals: boolean; printer_checked_at: string | null };
  bureau: boolean; demo: boolean; club_name: string; fn: { id: string; name: string; holders: string[] } | null;
  sales_month: { n: number; cents: number }; month: string;
  items: ShopItem[]; groups: Group[]; rounds: AdminRound[]; ready: ReadyLine[]; printer_items: PrinterItem[];
  refunds: { id: string; ref: string; buyer: string; total_cents: number }[];
}

// --- Les prix --------------------------------------------------------------------------------------------------------
const NB = ' ';   // espace insécable
/** « 39 € », « 12,50 € » ; `bare` : « 39 » (le prix en grand). */
export function euros(cents: number, bare = false): string {
  const c = Math.round(cents);
  const s = c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2).replace('.', ',');
  const grouped = s.replace(/^(\d+)(\d{3})/, `$1${NB}$2`);
  return bare ? grouped : `${grouped}${NB}€`;
}
/** « 61,00 € » : le total d'un paiement (toujours avec les centimes). */
export const eurosExact = (cents: number) => `${(Math.round(cents) / 100).toFixed(2).replace('.', ',').replace(/^(\d+)(\d{3})/, `$1${NB}$2`)}${NB}€`;
/** Un prix tapé (« 39 », « 12,5 », « 12,50 € ») en centimes ; null s'il ne se lit pas. */
export function parseEuros(s: string): number | null {
  const t = s.replace(/[€\s ]/g, '').replace(',', '.');
  if (!/^\d{1,5}(\.\d{1,2})?$/.test(t)) return null;
  const c = Math.round(Number(t) * 100);
  return c <= 100000 ? c : null;
}

/** Le prix d'un article d'une commande groupée, flocage compris (le même calcul que la base). */
export function unitPrice(p: Pick<Product, 'price_cents'>, r: Pick<Round, 'flock_name_cents' | 'flock_number_cents'>, name: string | null, number: number | null): number {
  return p.price_cents + (name ? r.flock_name_cents ?? 0 : 0) + (number !== null ? r.flock_number_cents ?? 0 : 0);
}

// --- Le stock dit en mots ----------------------------------------------------------------------------------------------
export const stockOf = (i: Pick<ShopItem, 'sizes'>) => i.sizes.reduce((n, s) => n + Math.max(0, s.n), 0);
export const oneSize = (i: Pick<ShopItem, 'sizes'>) => i.sizes.length === 1 && !i.sizes[0]!.s;
/** Ce que voit le membre sous le prix (c1) : « Dernières pièces en S et M », « S · M · XL », « En stock », « Bientôt de retour ». */
export function memberStockLine(i: Pick<ShopItem, 'sizes'>): { text: string; tone: '' | 'low' | 'out' } {
  if (!stockOf(i)) return { text: 'Bientôt de retour', tone: 'out' };
  if (oneSize(i)) return i.sizes[0]!.n <= 2 ? { text: 'Dernières pièces', tone: 'low' } : { text: 'En stock', tone: '' };
  const low = i.sizes.filter(s => s.n > 0 && s.n <= 2).map(s => s.s);
  if (low.length) return { text: `Dernières pièces en ${low.length > 1 ? `${low.slice(0, -1).join(', ')} et ${low[low.length - 1]}` : low[0]}`, tone: 'low' };
  return { text: i.sizes.filter(s => s.n > 0).map(s => s.s).join(' · '), tone: '' };
}
/** Ce que voit la personne Boutique (b3) : « Stock 11 », « Stock 0 · réassort à commander » ; bas : 7 et moins. */
export function managerStockLine(i: Pick<ShopItem, 'sizes'>): { text: string; tone: '' | 'low' | 'out' } {
  const n = stockOf(i);
  if (!n) return { text: 'Stock 0 · réassort à commander', tone: 'out' };
  return { text: `Stock ${n}`, tone: n <= 7 ? 'low' : '' };
}
/** Les tailles encore commandables. */
export const sizesInStock = (i: Pick<ShopItem, 'sizes'>) => i.sizes.filter(s => s.n > 0).map(s => s.s);

/** Les tailles d'usage, dans l'ordre des catalogues : les âges, puis XS → 4XL, puis le reste (pointures…). */
const SIZE_ORDER = ['4 ans', '6 ans', '8 ans', '10 ans', '12 ans', '14 ans', '16 ans', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];
export function sortSizes(list: readonly string[]): string[] {
  const rank = (s: string) => { const k = SIZE_ORDER.indexOf(s.trim()); return k < 0 ? 100 + (parseInt(s, 10) || 0) : k; };
  return [...new Set(list)].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b, 'fr'));
}
/** Les tailles proposées pour une commande groupée (b6) : « 8 ans → XXL ». */
export const SIZE_PRESETS: { key: string; label: string; sizes: string[] }[] = [
  { key: 'enfant-adulte', label: '8 ans → XXL', sizes: ['8 ans', '10 ans', '12 ans', '14 ans', 'S', 'M', 'L', 'XL', 'XXL'] },
  { key: 'adulte', label: 'XS → XXL', sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
  { key: 'enfant', label: '6 ans → 14 ans', sizes: ['6 ans', '8 ans', '10 ans', '12 ans', '14 ans'] },
  { key: 'unique', label: 'Taille unique', sizes: ['Taille unique'] },
];
/** « 8 ans → XXL », « taille unique ». */
export function sizesRange(sizes: readonly string[]): string {
  const s = sortSizes(sizes);
  if (s.length === 1) return s[0]!.toLowerCase() === 'taille unique' ? 'taille unique' : s[0]!;
  return `${s[0]} → ${s[s.length - 1]}`;
}

// --- Le flocage --------------------------------------------------------------------------------------------------------
/** Le nom à floquer : majuscules, 12 lettres au plus (lettres, espace, trait d'union, apostrophe). null : invalide. */
export function flockName(s: string): string | null {
  const t = s.trim().replace(/\s+/g, ' ').toUpperCase();
  if (!t) return null;
  return /^[A-ZÀÂÄÇÉÈÊËÎÏÔÖÙÛÜŸŒÆ' -]{1,12}$/.test(t) ? t : null;
}
export const flockNumber = (s: string): number | null => (/^\d{1,2}$/.test(s.trim()) ? Number(s.trim()) : null);
/** « KENZA 4 », « 12 », « TESS ». */
export const flockLabel = (name: string | null, number: number | null) => [name, number ?? null].filter(x => x !== null && x !== '').join(' ');

// --- Les dates -------------------------------------------------------------------------------------------------------
const DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
const MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
const MON = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
interface Parts { y: number; m: number; d: number; wd: number; h: number; mi: number }
function parts(iso: string): Parts {
  const p = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'long', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
    .formatToParts(new Date(iso)).reduce<Record<string, string>>((o, x) => ({ ...o, [x.type]: x.value }), {});
  return { y: Number(p.year), m: Number(p.month), d: Number(p.day), wd: DAYS.indexOf(p.weekday ?? ''), h: Number(p.hour), mi: Number(p.minute) };
}
const er = (d: number) => (d === 1 ? '1er' : String(d));
/** « vendredi 20 nov. » */
export const dayShort = (iso: string) => { const p = parts(iso); return `${DAYS[p.wd]} ${er(p.d)} ${MON[p.m - 1]}`; };
/** « 20 nov. » */
export const dateShort = (iso: string) => { const p = parts(iso); return `${er(p.d)} ${MON[p.m - 1]}`; };
/** « 15 septembre » */
export const dateLong = (iso: string) => { const p = parts(iso); return `${er(p.d)} ${MONTHS[p.m - 1]}`; };
/** Le nombre de jours (calendaires, heure de Paris) jusqu'à `iso`. */
export function daysUntil(iso: string, now = new Date()): number {
  const a = parts(now.toISOString()), b = parts(iso);
  return Math.round((Date.UTC(b.y, b.m - 1, b.d) - Date.UTC(a.y, a.m - 1, a.d)) / 864e5);
}

// --- Une commande groupée ------------------------------------------------------------------------------------------------
/** Le titre d'une fenêtre : « Commande de novembre » (un mois), « Commande de rentrée » (une fois). */
export const roundTitle = (r: Pick<Round, 'kind' | 'label' | 'name'>) => (r.kind === 'month' ? `Commande de ${r.label}` : r.name);
/** Le titre côté personne Boutique (b5) : « Commande du mois · novembre ». */
export const roundAdminTitle = (r: Pick<Round, 'kind' | 'label' | 'name'>) => (r.kind === 'month' ? `${r.name} · ${r.label}` : r.name);
/** « Du 1er au 20 de chaque mois » ; « Jusqu'au 15 septembre ». */
export function windowLine(r: Pick<Round, 'kind' | 'day_from' | 'day_to' | 'closes_at'>): string {
  return r.kind === 'month' && r.day_from && r.day_to ? `Du ${er(r.day_from)} au ${r.day_to} de chaque mois` : `Jusqu’au ${dateLong(r.closes_at)}`;
}
/** « Clôture vendredi 20 nov. à 23h59 » */
export function closeLine(closesAt: string): string {
  const p = parts(closesAt);
  return `Clôture ${dayShort(closesAt)} à ${p.h}h${String(p.mi).padStart(2, '0')}`;
}
/** « Encore 8 jours », « Dernier jour », « Demain ». */
export function leftLine(closesAt: string, now = new Date()): string {
  const n = daysUntil(closesAt, now);
  return n <= 0 ? 'Dernier jour' : n === 1 ? 'Encore 1 jour' : `Encore ${n} jours`;
}
/** La prochaine fenêtre d'une commande de chaque mois : « prochaine commande du 1er au 20 décembre ». */
export function nextWindowLine(r: Pick<Round, 'kind' | 'day_from' | 'day_to' | 'closes_at'>): string | null {
  if (r.kind !== 'month' || !r.day_from || !r.day_to) return null;
  const p = parts(r.closes_at);
  const m = p.m % 12;
  return `prochaine commande du ${er(r.day_from)} au ${r.day_to} ${MONTHS[m]}`;
}
/** La barre (b5, c1, c6) : le remplissage et le repère du minimum, en % ; sans minimum, pas de barre. */
export function progress(pieces: number, min: number | null): { pct: number; mark: number; ok: boolean } | null {
  if (!min) return null;
  const max = Math.max(Math.ceil(min * 1.5), pieces);
  return { pct: Math.min(100, Math.round((100 * pieces) / max)), mark: Math.round((100 * min) / max), ok: pieces >= min };
}
/** « minimum 20 ✓ », « minimum 20 · il en manque 4 ». */
export function minLine(pieces: number, min: number | null): string | null {
  if (!min) return null;
  return pieces >= min ? `minimum ${min} ✓` : `minimum ${min} · il en manque ${min - pieces}`;
}
/** « Minimum 20 pièces : atteint, la commande partira » (c6). */
export function minSentence(pieces: number, min: number | null): string | null {
  if (!min) return null;
  return pieces >= min ? `Minimum ${min} pièces : atteint, la commande partira` : `Minimum ${min} pièces : il en manque ${min - pieces} pour que la commande parte`;
}

export type Step = { t: string; s: string; st: 'done' | 'cur' | '' };
/** Le suivi d'une fenêtre (b5, b9) : Close → Commandée → Reçue → À retirer. */
export function roundSteps(r: Pick<AdminRound, 'state' | 'closed_at' | 'closes_at' | 'ordered_at' | 'received_at' | 'to_give' | 'given'>): Step[] {
  const order: RoundState[] = ['closed', 'ordered', 'received', 'done'];
  const k = r.state === 'open' ? -1 : order.indexOf(r.state === 'cancelled' ? 'closed' : r.state);
  const total = r.to_give + r.given;
  return [
    { t: 'Close', s: dateShort(r.closed_at ?? r.closes_at), st: k >= 0 ? 'done' : 'cur' },
    { t: 'Commandée', s: r.ordered_at ? dateShort(r.ordered_at) : 'à envoyer', st: k >= 1 ? 'done' : k === 0 ? 'cur' : '' },
    { t: 'Reçue', s: r.received_at ? dateShort(r.received_at) : '', st: k >= 2 ? 'done' : k === 1 ? 'cur' : '' },
    { t: 'À retirer', s: total ? `${r.given} / ${total}` : '', st: k >= 3 ? 'done' : k === 2 ? 'cur' : '' },
  ];
}
/** Le suivi d'un article (c7) : au club, Payé → À retirer → Remis ; commande groupée, Payée → Commandée → Reçue → À retirer
 *  (ou Remise). */
export function lineSteps(l: Pick<OrderLine, 'kind' | 'state' | 'given_at' | 'ready_at' | 'round'>, paidAt: string | null): Step[] {
  const paid = { t: 'Payée', s: paidAt ? dateShort(paidAt) : '', st: 'done' as const };
  if (l.kind === 'club') {
    return [paid, { t: 'À retirer', s: 'au club', st: l.state === 'given' ? 'done' : 'cur' },
      { t: 'Remise', s: l.given_at ? dateShort(l.given_at) : '', st: l.state === 'given' ? 'done' : '' }];
  }
  const r = l.round;
  const k = ({ pending: 0, paid: 0, ordered: 1, ready: 3, given: 4, cancelled: 0 } as const)[l.state];
  const closes = r ? `après le ${dateShort(r.closes_at)}` : '';
  const last = l.state === 'given' ? { t: 'Remise', s: l.given_at ? dateShort(l.given_at) : '', st: 'done' as const }
    : { t: 'À retirer', s: 'au club', st: (k === 3 ? 'cur' : '') as Step['st'] };
  return [paid,
    { t: 'Commandée', s: r?.ordered_at ? dateShort(r.ordered_at) : closes, st: k >= 1 ? 'done' : 'cur' },
    { t: 'Reçue', s: r?.received_at ? dateShort(r.received_at) : r?.delivery_note ? deliveryShort(r.delivery_note) : '', st: k >= 3 ? 'done' : k === 1 ? 'cur' : '' },
    last];
}
/** « Livraison mi-décembre » → « mi-déc. » : la date prévue, courte. */
export function deliveryShort(note: string): string {
  const t = note.replace(/^livraison\s+/i, '').replace(/,.*$/, '').trim();
  return t.replace(/janvier/i, 'janv.').replace(/février/i, 'févr.').replace(/septembre/i, 'sept.').replace(/octobre/i, 'oct.').replace(/novembre/i, 'nov.').replace(/décembre/i, 'déc.');
}
/** La pastille d'un article dans « Mes commandes » : « à retirer », « payé », « commandé », « remis le 7 oct. ». */
export function lineChip(l: Pick<OrderLine, 'state' | 'given_at'>): { t: string; tone: 'ok' | 'mute' | 'accent' } {
  if (l.state === 'ready') return { t: 'à retirer', tone: 'ok' };
  if (l.state === 'given') return { t: `remis le ${l.given_at ? dateShort(l.given_at) : ''}`.trim(), tone: 'mute' };
  if (l.state === 'ordered') return { t: 'commandé', tone: 'mute' };
  if (l.state === 'cancelled') return { t: 'annulé', tone: 'mute' };
  return { t: 'payé', tone: 'mute' };
}

// --- Le récapitulatif pour l'équipementier (b8) -------------------------------------------------------------------------
export interface Recap {
  group: string; label: string; kind: 'month' | 'once'; state: RoundState; closes_at: string; min_pieces: number | null; pieces: number; families: number; paid_cents: number;
  products: { name: string; sizes: string[]; counts: Record<string, number> }[];
  flocks: { product: string; size: string; name: string | null; number: number | null; qty: number }[];
}
/** Le tableau article × taille : les colonnes (les tailles commandées, dans l'ordre des catalogues), une ligne par article
 *  avec son total, le total général. */
export function recapTable(r: Pick<Recap, 'products'>): { cols: string[]; rows: { name: string; cells: number[]; total: number; unique: boolean }[]; total: number } {
  const cols = sortSizes(r.products.flatMap(p => Object.keys(p.counts).filter(s => !/^taille unique$/i.test(s))));
  const rows = r.products.map(p => {
    const unique = Object.keys(p.counts).every(s => /^taille unique$/i.test(s) || s === '');
    const total = Object.values(p.counts).reduce((n, x) => n + x, 0);
    return { name: p.name, cells: cols.map(c => p.counts[c] ?? 0), total, unique };
  });
  return { cols, rows, total: rows.reduce((n, x) => n + x.total, 0) };
}
/** Le tableur pour l'équipementier : article, taille, quantité ; puis les flocages (article, taille, nom, numéro). Ni qui a
 *  commandé, ni son équipe, ni son âge. Séparateur « ; », BOM pour Excel. */
export function recapCsv(r: Recap, club: string): string {
  const q = (s: string | number) => { const t = String(s); return /[;"\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t; };
  const lines: string[] = [`${q(club)};${q(r.kind === 'month' ? `${r.group} · ${r.label}` : r.group)}`, '', 'Article;Taille;Quantité'];
  for (const p of r.products) for (const s of sortSizes(Object.keys(p.counts))) lines.push(`${q(p.name)};${q(s || 'Taille unique')};${p.counts[s]}`);
  lines.push(`Total;;${r.products.reduce((n, p) => n + Object.values(p.counts).reduce((a, b) => a + b, 0), 0)}`);
  if (r.flocks.length) {
    lines.push('', 'Flocage', 'Article;Taille;Nom;Numéro;Quantité');
    for (const f of r.flocks) lines.push(`${q(f.product)};${q(f.size || 'Taille unique')};${q(f.name ?? '')};${f.number ?? ''};${f.qty}`);
  }
  return `﻿${lines.join('\r\n')}\r\n`;
}

/** « Claire (gourde), Pascal (sweat M), Inès (chaussettes 39-42) » : une commande prête par personne (b3). */
export function readyWho(lines: readonly Pick<ReadyLine, 'order' | 'buyer' | 'for' | 'name' | 'size'>[]): string[] {
  const short = (n: string) => (n.split(/[\s’']/)[0] ?? n).toLowerCase();
  const who = (l: Pick<ReadyLine, 'buyer' | 'for'>) => (l.for ?? l.buyer).replace(/^Famille (de |d’)?/, '').split(' ')[0] ?? '';
  return [...new Map(lines.map(l => [l.order, `${who(l)} (${short(l.name)}${l.size && !/^taille unique$/i.test(l.size) ? ` ${l.size}` : ''})`])).values()];
}

// --- L'« À faire » de la personne Boutique (au-dessus des onglets, tous rayons confondus) ------------------------------------
export interface Todo { k: string; t: string; s: string; href: string; hot?: boolean }
export function todoOf(a: Pick<AdminState, 'settings' | 'ready' | 'rounds' | 'printer_items' | 'refunds' | 'demo'>, now = new Date()): Todo[] {
  const out: Todo[] = [];
  const st = a.settings;
  const mine = a.ready.filter(l => l.kind === 'club' || !a.rounds.find(r => r.id === l.round_id)?.coach_handover);
  const orders = new Set(mine.map(l => l.order));
  if (orders.size) {
    const who = readyWho(mine);
    out.push({ k: 'remettre', t: `${orders.size} ${orders.size > 1 ? 'commandes prêtes' : 'commande prête'} à remettre`,
      s: `${who.slice(0, 3).join(', ')}${who.length > 3 ? '…' : ''}${st.pickup_when ? ` · ${st.pickup_when}` : ''}`, href: '#/boutique/remises', hot: true });
  }
  for (const r of a.rounds) {
    const title = roundAdminTitle(r);
    if (r.state === 'closed') {
      const short = r.min_pieces && r.pieces < r.min_pieces;
      out.push({ k: `cloture:${r.id}`, t: short ? `${title} : minimum pas atteint` : `${title} : à envoyer à l’équipementier`,
        s: short ? `${r.pieces} pièces sur ${r.min_pieces} · commander quand même ou annuler` : `${r.pieces} pièces · le récapitulatif est prêt`, href: `#/boutique/cloture/${r.id}`, hot: true });
    } else if (r.state === 'open' && daysUntil(r.closes_at, now) <= 3 && new Date(r.opens_at) <= now) {
      out.push({ k: `bientot:${r.id}`, t: `${title} : clôture ${dayShort(r.closes_at)}`, s: `${r.pieces} pièces${r.min_pieces ? ` · minimum ${r.min_pieces}` : ''}`, href: '#/boutique/gestion/groupees' });
    } else if (r.state === 'ordered') {
      out.push({ k: `arrivee:${r.id}`, t: `${title} : commandée le ${dateShort(r.ordered_at ?? r.closes_at)}`, s: '« C’est arrivé » quand tu la reçois : les familles sont prévenues', href: `#/boutique/remises/${r.id}` });
    }
  }
  for (const x of a.printer_items.filter(p => p.state === 'missing')) {
    out.push({ k: `imprimeur:${x.id}`, t: `« ${x.name} » n’existe plus chez l’imprimeur`, s: 'Masqué de la vitrine · remplacer ou retirer', href: '#/boutique/gestion/imprimeur', hot: true });
  }
  if (a.refunds.length) {
    out.push({ k: 'rembourser', t: `${a.refunds.length} ${a.refunds.length > 1 ? 'paiements à rembourser' : 'paiement à rembourser'}`,
      s: 'Depuis l’espace HelloAsso du club : ' + a.refunds.slice(0, 3).map(r => `${r.ref} (${euros(r.total_cents)})`).join(', '), href: '#/boutique/gestion/groupees' });
  }
  const needsPay = st.sell_club || st.sell_group;
  if (needsPay && !a.demo && st.ha_state !== 'ok') {
    out.push({ k: 'helloasso', t: st.ha_state === 'unverified' ? 'L’association n’est pas encore vérifiée chez HelloAsso' : st.ha_state === 'error' ? 'HelloAsso : la liaison ne répond plus'
      : 'Relier le compte HelloAsso du club', s: 'Sans lui, « Au club » et la commande groupée ne prennent pas de paiement en ligne', href: '#/boutique/reglages/helloasso', hot: true });
  }
  if (st.sell_printer && !st.printer_url) out.push({ k: 'imprimeur-lien', t: 'Coller l’adresse de ta boutique chez l’imprimeur', s: 'Le rayon « Livré chez vous » reste caché d’ici là', href: '#/boutique/gestion/imprimeur' });
  return out;
}

// --- L'imprimeur -------------------------------------------------------------------------------------------------------
/** La même règle que la base (_shop_https_ok) : https seulement, un vrai nom d'hôte, ni adresse IP ni nom local. */
export function httpsOk(url: string): boolean {
  const u = url.trim();
  if (u.length > 600 || /\s/.test(u)) return false;
  const l = u.toLowerCase();
  if (!/^https:\/\/[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+(:[0-9]{2,5})?([/?#][^\s]*)?$/.test(l)) return false;
  if (/^https:\/\/[0-9]+(\.[0-9]+){3}(:[0-9]+)?([/?#]|$)/.test(l)) return false;
  return !/^https:\/\/[^/?#:]+\.(local|localhost|internal|lan|home|arpa)\.?(:[0-9]+)?([/?#]|$)/.test(l);
}
/** Le nom d'un imprimeur reconnu d'après l'adresse (sans affiliation : on le nomme seulement) ; sinon, son domaine. */
export function printerOf(url: string): { name: string; known: boolean; host: string } {
  let host = '';
  try { host = new URL(url.trim()).hostname.replace(/^www\./, ''); } catch { return { name: '', known: false, host: '' }; }
  if (/(^|\.)myspreadshop\.[a-z.]+$|(^|\.)spreadshirt\.[a-z.]+$|(^|\.)spreadshop\.[a-z.]+$/.test(host)) return { name: 'Spreadshop', known: true, host };
  if (/(^|\.)owayo\.[a-z.]+$/.test(host)) return { name: 'owayo', known: true, host };
  return { name: host, known: false, host };
}
/** « Vérifié il y a 2 jours », « Vérifié aujourd'hui », « Pas encore vérifié ». */
export function checkedLine(iso: string | null | undefined, now = new Date()): string {
  if (!iso) return 'Pas encore vérifié';
  const n = -daysUntil(iso, now);
  return n <= 0 ? 'Vérifié aujourd’hui' : n === 1 ? 'Vérifié hier' : `Vérifié il y a ${n} jours`;
}
export const PRINTER_MAX = 12;

// --- Mineurs (D-103) ---------------------------------------------------------------------------------------------------------
/** « Montrer à Claire », « Montrer à mes parents », « Montrer à mon parent ». */
export function showParentLabel(parents: readonly string[]): string {
  if (parents.length === 1) return `Montrer à ${parents[0]}`;
  return parents.length > 1 ? 'Montrer à mes parents' : 'Montrer à mon parent';
}

// --- Le panier -----------------------------------------------------------------------------------------------------------
export type CartLine =
  | { kind: 'club'; item: string; size: string; qty: number; name: string; picto: Picto | null; unit_cents: number }
  | { kind: 'group'; round: string; product: string; size: string; qty: number; for: string | null; for_label: string; flock_name: string | null; flock_number: number | null;
      name: string; picto: Picto | null; unit_cents: number };
export const cartTotal = (lines: readonly CartLine[]) => lines.reduce((n, l) => n + l.qty * l.unit_cents, 0);
export const cartCount = (lines: readonly CartLine[]) => lines.reduce((n, l) => n + l.qty, 0);
/** Ajouter au panier : la même ligne (même article, même taille, même personne, même flocage) prend une pièce de plus. */
export function cartAdd(lines: readonly CartLine[], add: CartLine): CartLine[] {
  const same = (l: CartLine) => l.kind === add.kind && l.size === add.size && (l.kind === 'club' ? add.kind === 'club' && l.item === add.item
    : add.kind === 'group' && l.product === add.product && l.round === add.round && l.for === add.for && l.flock_name === add.flock_name && l.flock_number === add.flock_number);
  const k = lines.findIndex(same);
  if (k < 0) return [...lines, add];
  return lines.map((l, i) => (i === k ? { ...l, qty: Math.min(10, l.qty + add.qty) } : l));
}
/** Ce que la base reçoit (shop_order_create) : les identifiants, les tailles, le flocage ; jamais un prix. */
export function cartPayload(lines: readonly CartLine[]): Record<string, unknown>[] {
  return lines.map(l => (l.kind === 'club' ? { kind: 'club', item: l.item, size: l.size, qty: l.qty }
    : { kind: 'group', round: l.round, product: l.product, size: l.size, qty: l.qty, for: l.for, flock_name: l.flock_name, flock_number: l.flock_number }));
}
/** Les lignes encore valables quand la boutique a changé (un article retiré, une fenêtre close, une taille épuisée). */
export function cartValid(lines: readonly CartLine[], st: Pick<ShopState, 'items' | 'rounds'>): CartLine[] {
  return lines.filter(l => {
    if (l.kind === 'club') { const it = st.items.find(i => i.id === l.item); return !!it && (it.sizes.find(s => s.s === l.size)?.n ?? 0) >= l.qty; }
    const r = st.rounds.find(x => x.id === l.round && !x.upcoming);
    return !!r && r.products.some(p => p.id === l.product && p.sizes.includes(l.size));
  });
}
